import { gql } from "@outschool/ui-apollo";

export default gql`
  query ContentfulHomePage2($locale: String, $preview: Boolean) {
    contentfulHomePage2Collection(
      limit: 1
      skip: 0
      preview: $preview
      locale: $locale
    ) {
      items {
        title
        heroSlidesCollection {
          items {
            title
            image {
              url
            }
          }
        }
        popularSearchLinksCollection {
          items {
            text
            path
          }
        }
        valuePropsCollection {
          items {
            title
            icon {
              url
            }
          }
        }
        visualLinkGridsCollection {
          items {
            title
            style
            visualLinksCollection {
              items {
                text
                path
                image {
                  url
                }
                imageAltText
                imageAspectRatio
              }
            }
          }
        }
      }
    }
  }
`;
